import React from 'react';
import styles from './_style.module.scss';

const SelectUnit = ({ id, drawing, unit, setUnit }) => {
  const selectUnit = (selectedUnit) => {
    setUnit(() => selectedUnit);
  };

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>{t('my_drawings.options_unit_short')}</label>
      <div className={styles.unitToggle}>
        <button
          type="button"
          className={`${styles.unitButton} ${unit === 'mm' ? styles.unitButtonActive : ''}`}
          onClick={() => selectUnit('mm')}
        >
          {t('drawing.unit_mm')}
        </button>
        <button
          type="button"
          className={`${styles.unitButton} ${unit === 'in' ? styles.unitButtonActive : ''}`}
          onClick={() => selectUnit('in')}
        >
          {t('drawing.unit_in')}
        </button>
      </div>
    </div>
  );
};

export default SelectUnit;
